import React from 'react';
import PropTypes from 'prop-types';

const PdxNavPanelSection = ({ gray, split, children }) => {
  let classNames = split ? 'pdx-nav-split-panel-section' : 'pdx-nav-panel-section';
  if (gray) classNames += ' gray';
  const splitPanelWidth = `${gray ? 320 : 240}px`;
  const style = { width: `${split ? splitPanelWidth : '100%'}` };
  return (
    <div className={classNames} style={style}>
      {children}
      <span className="magicLine" style={{ '--items': 5 }} />
    </div>
  );
};

PdxNavPanelSection.defaultProps = {
  gray: false,
  split: false,
};

PdxNavPanelSection.propTypes = {
  gray: PropTypes.bool,
  split: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string
  ]).isRequired
};

export default PdxNavPanelSection;
